<h2>{{ 'SIGNUP.HEADING' | transloco }}</h2>

<form
  [formGroup]="loginForm"
  (ngSubmit)="loginForm.valid && login(loginForm.get('email').value, loginForm.get('password').value)">
  <label for="email">{{ 'CORE.EMAIL' | transloco }}</label>

  <mat-form-field class="fw">
    <input
      matInput
      formControlName="email"
      type="email"
      placeholder="{{ 'CORE.EMAIL_PLACEHOLDER' | transloco }}"
      (change)="loginForm.controls['email'].setValue($event.target.value)" />
    <mat-error *ngIf="loginForm.get('email').hasError('email') && !loginForm.get('email').hasError('required')">
      {{ 'CORE.VALID_EMAIL' | transloco }}
    </mat-error>

    <mat-error *ngIf="loginForm.get('email').hasError('required')">
      {{ 'CORE.EMAIL' | transloco }} {{ 'CORE.IS_REQUIRED' | transloco }}
    </mat-error>
  </mat-form-field>

  <ng-container>
    <label for="password">{{ 'CORE.PASSWORD' | transloco }}</label>
    <mat-form-field class="fw">
      <input
        matInput
        type="password"
        formControlName="password"
        placeholder="{{ 'CORE.PASSWORD_PLACEHOLDER' | transloco }}"
        (change)="loginForm.controls['password'].setValue($event.target.value)" />
      <mat-error *ngIf="loginForm.get('password').hasError('required')">
        {{ 'CORE.PASSWORD' | transloco }} {{ 'CORE.IS_REQUIRED' | transloco }}
      </mat-error>
    </mat-form-field>

    <sbnb-button [loading]="loading" [disabled]="generatingMagicLink" [fullWidth]="true" class="login__btn-submit">
      {{ 'CORE.LOGIN' | transloco }}
    </sbnb-button>
  </ng-container>
</form>

<span class="magic-link-or">or</span>

<div style="margin-top: 24px">
  <sbnb-button
    [htmlButtonType]="'button'"
    [disabled]="loading || generatingMagicLink"
    [loading]="generatingMagicLink"
    [fullWidth]="true"
    type="secondary"
    [label]="'CORE.MAGIC_LINK' | transloco"
    (clicked)="generateMagicLink()"></sbnb-button>
</div>

<!-- Signup link - not available on iOS due to Apple -->
<span
  *ngIf="!iosApp"
  class="login__register-link"
  fxLayout
  fxLayoutGap="8px"
  fxLayoutAlign="center center"
  fxLayout.lt-md="column">
  <span>{{ 'SIGNUP.PROMPT' | transloco }}</span>
  <a class="ocean strong" [routerLink]="['/user/register']">
    {{ 'SIGNUP.REGISTER' | transloco: { days: environment.trialLength } }}
  </a>
</span>

<!-- Forgot password link -->
<div class="login__links" fxLayout fxLayoutGap="8px" fxLayout.lt-md="column">
  <a
    fxFlex
    class="login__forgotpw-link ocean strong"
    [routerLink]="['/user/hello']"
    [queryParams]="{ mode: 'forgotpw' }"
    queryParamsHandling="default">
    {{ 'FORGOTPW.PROMPT' | transloco }}
  </a>
</div>
